import { render, staticRenderFns } from "./DashCredenciamento.vue?vue&type=template&id=2a7b7354"
import script from "./DashCredenciamento.vue?vue&type=script&lang=js"
export * from "./DashCredenciamento.vue?vue&type=script&lang=js"
import style0 from "./DashCredenciamento.vue?vue&type=style&index=0&id=2a7b7354&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports